var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.2 25.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28,9.67h0c.33,0,.6-.27.6-.6v-2.99c0-.33-.27-.6-.6-.6-.33,0-.6.27-.6.6v2.99c0,.33.27.6.6.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92,9.67h0c.33,0,.6-.27.6-.6v-2.99c0-.33-.27-.6-.6-.6-.33,0-.6.27-.6.6v2.99c0,.33.27.6.6.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.21,0h-1.46c-.69,0-1.3.36-1.66.9l-7.19,2.83c-.62-.62-1.47-1-2.42-1h-4.3c-1.53,0-2.81,1.02-3.25,2.41-.77.32-1.45.83-1.97,1.5-1.3,1.7-1.3,4.07,0,5.77.51.67,1.2,1.18,1.97,1.5.3.94.98,1.72,1.87,2.11l2.43,8.06c.29.99,1.21,1.67,2.25,1.67h2.29,0c.23,0,.46-.03.68-.1,1.24-.37,1.94-1.68,1.57-2.92l-2.04-6.77c.52-.25.97-.63,1.3-1.1l6.77,3.26s.02,0,.03.01c.36.55.97.91,1.67.91h1.46c1.1,0,1.99-.89,1.99-1.99V1.99c0-1.1-.89-1.99-1.99-1.99ZM4.77,6.14c0-.78.64-1.42,1.42-1.42h4.3c.78,0,1.42.64,1.42,1.42v6.74c0,.59-.36,1.09-.86,1.31h-5.41c-.51-.22-.86-.72-.86-1.31v-6.74ZM2.71,11.36c-.95-1.05-.95-2.65,0-3.7v3.7ZM12.12,23.38c0,.19-.16.35-.35.35h-2.29c-.15,0-.29-.1-.33-.25l-2.17-7.19h3.01l2.1,6.99s.01.07.01.1ZM13.85,5.51l5.92-2.33v12.57l-5.86-2.82s0-.03,0-.05v-6.74c0-.22-.03-.43-.06-.63ZM23.2,17.02h-1.44V2.11s.04-.07.06-.11h1.38v15.02Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack09);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-09.891c82cc73a738b1938e8f361c16573c.svg";
export { ForwardRef as ReactComponent };